/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".transparent[_nghost-%COMP%]   .disclaimer[_ngcontent-%COMP%]{background-color:transparent}.disclaimer[_ngcontent-%COMP%]{background-color:#f3f3f3;padding:60px 0}@media (max-width:767px){.disclaimer[_ngcontent-%COMP%]{padding:48px 0}}"];
export { styles as styles };
